/** Compute the chart plot bounds after edge padding and optional axis labels. */
export function chartPlotBox({ width, height, padding, yAxisAutoPad = 0, xAxisAutoPad = 0 }) {
    const left = padding.left + Math.max(0, Number(yAxisAutoPad) || 0);
    const top = padding.top;
    const right = padding.right;
    const bottom = padding.bottom + Math.max(0, Number(xAxisAutoPad) || 0);

    return {
        left,
        top,
        right,
        bottom,
        width: Math.max(1, width - left - right),
        height: Math.max(1, height - top - bottom),
    };
}

/** A side is exportable when set directly or through an explicit Overall value. */
export function shouldExportChartPaddingSide(overallTrace, sideTrace) {
    return (overallTrace?.explicit && !overallTrace.redundant)
        || (sideTrace?.explicit && !sideTrace.redundant);
}
